import { TranslationMap } from '@trimble-gcs/i18n-types';

export function singleSelectedTranslations() {
  return {
    title: {
      text: $localize`:@@recycleSingleSelected.title:Details`,
      desc: 'Title for the details panel that shows information about a selected recycled scan.',
    },
    close: {
      tooltip: {
        text: $localize`:@@recycleSingleSelected.close.tooltip:Close`,
        desc: "Tooltip for the top right 'X' button that closes the details panel and unselects the recycled scan.",
      },
    },
    preview: {
      notAvailable: {
        text: $localize`:@@recycleSingleSelected.preview.notAvailable:No preview available`,
        desc: 'Button tooltip when the preview of the selected scan is not available.',
      },
      hide: {
        text: $localize`:@@recycleSingleSelected.preview.hide:Hide preview`,
        desc: 'Button tooltip to hide the preview of the selected scan.',
      },
      show: {
        text: $localize`:@@recycleSingleSelected.preview.show:Show preview`,
        desc: 'Button tooltip to show the preview of the selected scan.',
      },
    },
  } satisfies TranslationMap;
}
